export default () => ({
  data() {
    return {
      selectedVersionIndex: 0,
      selectedColorIndex: 0
    }
  },
  filters: {
    formatVersionName(val) {
      return val.indexOf('@') > 0 ? val.split('@')[1] : val
    }
  },
  computed: {
    versionSpecId() {
      return this.specItem.specMain[0]
    },
    colorSpecId() {
      return this.specItem.specMain[1]
    },
    // 版本列表list
    versions() {
      return this.specItem.specItemSeq[this.versionSpecId]
    },
    // 颜色list
    colors() {
      return this.specItem.specItemSeq[this.colorSpecId]
    },
    colorsValid() {
      return this.specItem.specItemSeq[this.colorSpecId].filter(
        (item, index) => this.skuMap[`${this.selectedVersionIndex + 1}-${index + 1}`]
      )
    },
    currVersion() {
      return this.versions[this.selectedVersionIndex]
    },
    currColor() {
      return this.colors[this.selectedColorIndex]
    },
    currSkuId() {
      return this.skuMap[`${this.selectedVersionIndex + 1}-${this.selectedColorIndex + 1}`]
    },
    skuMap() {
      const map = {}
      const { skuSpecList, specMain } = this.specItem
      skuSpecList.forEach(sku => {
        const specItemIds = specMain.map(specId => sku.sequences[specId]).join('-')
        map[specItemIds] = sku.skuId
      })
      return map
    },
    selectedIndexs() {
      return this.selectedVersionIndex + '-' + this.selectedColorIndex
    }
  },
  watch: {
    // 选择发生了变化，那么重新请求sku
    selectedIndexs() {
      this.skuChange()
    },
    // 这是数据源
    specItem: {
      handler: function (val) {
        this.selectedVersionIndex =
          parseInt(val.skuSpecList.find(item => item.skuId === this.defaultSkuId).sequences[this.versionSpecId]) - 1
        this.selectedColorIndex =
          parseInt(val.skuSpecList.find(item => item.skuId === this.defaultSkuId).sequences[this.colorSpecId]) - 1
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    changeVersionIndex(index) {
      this.selectedVersionIndex = index
      // 切换版本后查看当前版本是否存在，如果不存在就选择第一个存在的
      if (!this.isValidateSku(index, this.selectedColorIndex)) {
        for (let i = 0; i <= this.colors.length; i++) {
          if (this.isValidateSku(index, i)) {
            this.selectedColorIndex = i
            break
          }
        }
      }
    },
    isValidateSku(versionIndex, colorIndex) {
      return this.skuMap[`${versionIndex + 1}-${colorIndex + 1}`]
    },
    changeColorIndex(index) {
      this.selectedColorIndex = index
    }
  }
})
